import React from 'react'

const Footer = () => {
  return (
    <div className='text-center py-2 border-t border-darklight'>
      © 2023 copyright all right reserved
    </div>
  )
}

export default Footer
